import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[wcgScrollOffsetY]',
})
export class ScrollOffsetYDirective {
  calculateSiblingOffSetY = input<boolean>(false);
  windowScrollYOffset = output<boolean>();
  private readonly _elementRef = inject(ElementRef<HTMLElement>);

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    event.stopPropagation();
    const previousElementOffsetTop = this.calculateSiblingOffSetY()
      ? this._elementRef.nativeElement.previousElementSibling
          ?.previousElementSibling?.offsetTop + 75 // Adding an extra 75 offset for safe_side
      : 0;
    const currentWindowScrollY = window.scrollY + previousElementOffsetTop;
    this.windowScrollYOffset.emit(
      currentWindowScrollY > this._elementRef.nativeElement.offsetTop,
    );
  }
}
